module.exports = __webpack_public_path__ + "img/cover.f0d5e85d.png";